<template>
  <div id="footer-component" class="d-flex align-items-start border-top border-white border-2 text-small text-white ps-2 pt-1 mb-1">
    <p class="me-2">MPP © {{ currentDate}} </p>
    <p id="footer-legal-label" class="clickable" @click="$router.push('/legal')">Mentions legales </p>
    <p class="ms-2">v{{ APP_VERSION }}</p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";

import { format } from 'date-fns'

import {
  TEXT_KEYS,
  APP_VERSION } from "@/constants";


@Options({
  components: {
  }
})
export default class Header extends Vue {
  languageStore = useLanguageStore()

  APP_VERSION = APP_VERSION

  get copyright() {
    return this.languageStore.text(TEXT_KEYS.FOOTER_DATE_LABEL)
  }

  get buttonSearch() {
    return this.languageStore.text(TEXT_KEYS.FOOTER_LEGAL_LABEL)
  }

  get currentDate() {
    return format(new Date(), 'yyyy')
  }
}
</script>

<style lang="stylus">
#footer-component {
    height: 1.5rem;
}

#footer-legal-label:hover {
    text-decoration: underline 
}
</style>